module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-pickwick-intro-card1.1@2x.66242d1a.jpg";